import { render } from "./Backend.vue?vue&type=template&id=174b91ef&scoped=true&ts=true"
import script from "./Backend.vue?vue&type=script&lang=ts"
export * from "./Backend.vue?vue&type=script&lang=ts"

import "./Backend.vue?vue&type=style&index=0&id=174b91ef&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\WebstormProjects\\wisevet-live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174b91ef"]])

export default __exports__